import {
	useMutation,
	useQueryClient,
	useSuspenseQuery,
} from "@tanstack/react-query";
import type { MetaAdsRole } from "shared";
import { Api } from "../api.config";
import { AlertType, useAlertEmit } from "../common/alert/Alert";
import { useCompany } from "../company/useCompany";
import { QueryKeys } from "../LinkGen";

export const useMetaAdsRoles = () => {
	const company = useCompany();
	return useSuspenseQuery({
		queryKey: QueryKeys.Integrations.MetaAds.Roles(company.id),
		queryFn: () => Api.GetMetaAdsRoles().then((r) => r.data),
	});
};

export const useMetaAdsRolesActions = () => {
	const queryClient = useQueryClient();
	const company = useCompany();
	const emit = useAlertEmit();

	const setRole = useMutation({
		mutationFn: async ({
			userId,
			role,
		}: {
			userId: number;
			role: MetaAdsRole;
		}) => {
			await Api.SetMetaAdsRole({ userId, role });
			await queryClient.refetchQueries({
				queryKey: QueryKeys.Integrations.MetaAds.Roles(company.id),
			});
			emit({
				type: AlertType.SUCCESS,
				content: "Meta Ads role updated.",
			});
		},
	});

	const removeRole = useMutation({
		mutationFn: async (userId: number) => {
			await Api.DeleteMetaAdsRole(userId);
			await queryClient.refetchQueries({
				queryKey: QueryKeys.Integrations.MetaAds.Roles(company.id),
			});
			emit({
				type: AlertType.SUCCESS,
				content: "Meta Ads role removed.",
			});
		},
	});

	return { setRole, removeRole };
};
